import { c as _c } from "react/compiler-runtime";
import { useIntl } from '@onefootprint/hooks';
import { requestWithoutCaseConverter } from '@onefootprint/request';
import type { DecryptUserRequest, DecryptUserResponse } from '@onefootprint/types';
import { AUTH_HEADER } from '@onefootprint/types';
import { useMutation } from '@tanstack/react-query';
const decryptUser = async ({
  fields,
  authToken
}: DecryptUserRequest, formatUtcDate: (date: Date) => string) => {
  const response = await requestWithoutCaseConverter<DecryptUserResponse>({
    method: 'POST',
    url: '/hosted/user/vault/decrypt',
    data: {
      fields
    },
    headers: {
      [AUTH_HEADER]: authToken
    }
  });
  const dobData = response.data['id.dob'] as string | undefined;
  if (dobData) {
    response.data['id.dob'] = formatUtcDate(new Date(dobData));
  }
  return response.data;
};
const useDecryptUser = () => {
  const $ = _c(2);
  const {
    formatUtcDate
  } = useIntl();
  let t0;
  if ($[0] !== formatUtcDate) {
    t0 = {
      mutationFn: data => decryptUser(data, formatUtcDate)
    };
    $[0] = formatUtcDate;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};
export default useDecryptUser;